import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const GetDepartments = createAsyncThunk('department-list', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-invoice/department-list`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListStudentInvoice = createAsyncThunk(
  'student-invoice-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-invoice/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const InvoiceSummary = createAsyncThunk('invoice-summary', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-invoice/invoice-summary`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get StudentList
export const ListStudent = createAsyncThunk('student-list', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-invoice/get-students`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetStdDepartment = createAsyncThunk(
  'student-department',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-invoice/get-student-department/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetStdSemester = createAsyncThunk(
  'student-department',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-invoice/get-student-semester/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create Student Invoice
export const createStudentInvoice = createAsyncThunk(
  'student-invoice-create',
  async (data: {}, thunkAPI) => {
    try {
      return await axios.post(`${api}student-invoice/store`, data)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get StudentList
export const GetStudentDetails = createAsyncThunk(
  'student-details',
  async ({id, type}: {id: string; type: string}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-invoice/get-student-details/${id}/${type}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const editStudentInvoiceInvoice = createAsyncThunk(
  'student-invoice-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student-invoice/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentInvoices = createAsyncThunk(
  'student-invoices',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-invoice/student-invoices/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PrintStudentInvoice = createAsyncThunk(
  'student-invoice-print',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-invoice/print/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PrintStudentExamCard = createAsyncThunk(
  'student-invoice-exam-card-print',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-invoice/print-exam-card/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteStudentInvoice = createAsyncThunk(
  'student-invoice-delete',
  async (id: string, thunkAPI) => {
    try {
      await axios.get(`${api}student-invoice/delete/${id}`)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetPayments = createAsyncThunk('get-payments', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-invoice/get-payments/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const CreateStudentInvoicePayment = createAsyncThunk(
  'student-invoice-payment-create',
  async (data: {}, thunkAPI) => {
    try {
      await axios.post(`${api}student-invoice/store-payment`, data)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PaymentDelete = createAsyncThunk('payment-delete', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-invoice/delete-payment/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const studentInvoiceDetails = createAsyncThunk(
  'student-invoice-details',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-invoice/view/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const changeInstallmentDate = createAsyncThunk(
  'change-installment-date',
  async (data: {}, thunkAPI) => {
    try {
      await axios.post(`${api}student-invoice/change-installment-date`, data)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStudentExamCard = createAsyncThunk(
  'student-exam-card-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-invoice/exam-card-list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStudentPaymentsReport = createAsyncThunk(
  'get-student-payments-report',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student-invoice/get-student-payments-report`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const printStudentPaymentsReport = createAsyncThunk(
  'print-student-payments-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-invoice/print-student-payments-report`, {
        params,
      })

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const studentPaymentsExcelReport = createAsyncThunk(
  'student-payments-excel-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-invoice/student-payments-excel-report`, {
        params,
        responseType: 'blob',
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

type StudentInvoiceState = {
  errors: any
}

const initialState: StudentInvoiceState = {
  errors: '',
}

export const studentInvoiceSlice = createSlice({
  name: 'student-invoice',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
})

export const {reset} = studentInvoiceSlice.actions
export default studentInvoiceSlice.reducer
